import { useGetUsersQuery } from "@/services/user.service";
import Breadcrumb from "@/components/Breadcrumb";
import { useEffect } from "react";
import TableComponent from "@/components/Table/TabelComponent";
import { LIMIT_PAGINATE } from "@/constants/default";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string"
import { dataQueryApi, dataQueryClient } from "@/utils/query";
import LimitPaginationComponent from "@/components/Table/LimitPaginationComponent";
import SearchComponent from "@/components/Table/SearchComponent";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import TableHeader from "./_header";

const defaultSort: string = 'created_at'
const defaultOrder: string = "desc"

const Users = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const parsed = queryString.parse(location?.search)
  const limit = _.isString(parsed.l) ? parseInt(parsed?.l) : LIMIT_PAGINATE
  const { data, refetch, isLoading, isFetching } = useGetUsersQuery(dataQueryApi(location?.search, {limit}), {refetchOnMountOrArgChange: true,});
  const {t} = useTranslation();

  const getData = (type: string, result: any) => {
    let data = dataQueryClient(location.search)
    switch (type) {
      case "search":
        data.s = result
        data.p = "1"
        break
      case "sort":
        data.o = result[0].desc ? "desc" : "asc"
        data.f = result[0].id
        break
      case "page":
        data.p = result
        break
      case "limit":
        data.l = result
        data.p = "1"
        break;
      default:
          data = { ...data };
          break;
    }
    navigate({
      search: createSearchParams(data).toString()
    })
  }

  useEffect(() => {
    if(location.state?.reload) {
      data?.data?.length === 1 && Number(parsed.p) !== 1 ? getData("page", 1) : refetch()
    }
  }, [location.state?.reload])

  return (
    <>
      <Breadcrumb pageName={t("user.users")} />
      <div className="flex flex-col gap-10">
        <div className="rounded-sm border border-stroke bg-white px-5 pt-5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-5 xl:pb-4">
          <div className="grid grid-cols-1 md:grid-cols-3">
            <div className="flex xs:flex-col flex-row col-span-2">
              <LimitPaginationComponent limit={limit} onChange={(s: number) => getData("limit", s)} />
              <SearchComponent search={parsed?.s?.toString() || ""} onChange={(s) => getData("search", s)} />
            </div>
            <div className="flex justify-start md:justify-end mt-2 md:mt-0">
              <div className="me-2">
                <button className="flex w-full justify-center items-center rounded bg-primary py-1.5 px-2 font-medium text-white text" onClick={refetch}><i className="fa-sharp fa-light fa-arrows-rotate me-2 text-white" />{t("table.reload")}</button>
              </div>
              <div>
                <button className="flex w-full justify-center items-center rounded bg-primary py-1.5 px-2 font-medium text-white text" onClick={() => navigate(location , {state: {modal: "/users/add"}})}><i className="fa-light fa-plus me-2 text-white" />{t("table.add")}</button>
              </div>
            </div>
          </div>
          
          <div className="max-w-full overflow-x-auto mt-3">
            <TableComponent
              data={data?.data || []}
              columns={TableHeader()}
              pageSize={limit}
              isPagination={true}
              currentPage={_.isString(parsed?.p) ? parseInt(parsed?.p) - 1 : 0}
              totalPages={Math.ceil((data?.total_records || 0) / limit)}
              onChangePage={(page: number) =>  getData("page", page+1)}
              isLoading={isLoading || isFetching}
              sort={[
                {
                    id: parsed?.f?.toString() || defaultSort,
                    desc: parsed?.o === defaultOrder ? true : false || true
                }
              ]}
              onChangeSort={data => getData("sort", data)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
